import React from 'react';
import { formatEffectiveDate } from '../helpers';

const ShippingPolicy = () => {
  return (
    <div className="container-fluid mt-5 mb-5">
      <div className="row">
        <div className="col-12 col-lg-10 offset-lg-1">
          <h1 className="display-4 fw-800 text-dark opacity-85 mb-4">Shipping & Delivery Policy</h1>
          <div className="card shadow-sm p-4 bg-white">
            <p className="text-muted mb-4">Effective Date: {formatEffectiveDate()}</p>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">1. Nature of Services</h5>
              <p className="text-dark opacity-75">
                JumpFast Technologies provides digital solutions and services. As such, no physical shipping or delivery of goods is required. All project components and deliverables are transmitted electronically.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">2. Delivery Method</h5>
              <p className="text-dark opacity-75">
                Digital deliverables are provided through secure, pre-approved channels, including but not limited to cloud storage links, collaboration tools, private repositories, or email, as specified in the project agreement.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">3. Delivery Timelines</h5>
              <p className="text-dark opacity-75">
                Delivery timelines are established during the project onboarding phase and documented in the project scope or contract. While we strive to meet all deadlines, unforeseen circumstances may lead to adjustments, which will be communicated promptly.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">4. Quality Verification</h5>
              <p className="text-dark opacity-75">
                Every deliverable undergoes a thorough internal quality assurance process before handover. Clients are encouraged to review and acknowledge receipt to ensure mutual clarity and satisfaction.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">5. Re-delivery or Access Issues</h5>
              <p className="text-dark opacity-75">
                If you experience issues accessing a delivered file or link, please contact our team immediately. We will verify access permissions and reissue the deliverables securely and promptly.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="fw-600 text-dark mb-3">6. Contact Us</h5>
              <p className="text-dark opacity-75">
                For questions regarding our Shipping & Delivery Policy or digital handover protocols, please email us at <a href="mailto:contact@jumpfast.tech" className="text-primary">contact@jumpfast.tech</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
